import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";

export default function Unauthorized({ userData }) {
    const cookies = new Cookies();
    const token = cookies.get("TOKEN");
    const navigate = useNavigate();
  
    useEffect(() => {
      // If token and userData are present, navigate to the map page
      if (token && userData && userData.status === "Active") {
        navigate("/auth/map");
      }
    }, [token, userData, navigate]);
  
    return (
      <div>
        <h1>Unauthorized Access</h1>
        <p>You do not have permission to view this page.</p>
      </div>
    );
}